import { UserLangService } from './../../services/common/user-lang/user-lang.service';
import {
  OnInit,
  Component,
  ViewContainerRef,
  Output,
  EventEmitter,
  signal,
  viewChild,
  input,
  ViewChild,
} from '@angular/core';

import { CustomForms } from '../forms/custom-forms';
import { AppComponent } from 'src/app/app.component';
import { MainComponent } from '../main/main.component';
import { environment } from 'src/environments/environment';
import { JqWidgets } from 'src/app/utils/jqWidgets';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CiudadanosService } from 'src/app/services/ciudadanos/ciudadanos.service';
import { CiudadanoModel } from 'src/app/services/ciudadanos/models/ciudadano.model';
import { CiudadanosEditComponent } from './ciudadanos-edit/ciudadanos-edit.component';
import { CiudadanosListadoTarjetasComponent } from './ciudadanos-listado-tarjetas/ciudadanos-listado-tarjetas.component';
import { TicketModel } from 'src/app/services/sso/models/ticket.model';
import { Utils } from 'src/app/utils/utils';
import { MapsService } from 'src/app/services/maps/maps.service';
import { MapComponent, MapLatLng } from 'movisat-maps';
import { RendererUtils } from 'src/app/utils/RendererUtils';
import { catchError, map, of, Subscription, tap } from 'rxjs';
import { ExportService } from 'src/app/services/export/export.service';
import { TarjetaListTransformerService } from 'src/app/services/type-list-transformer.service';
import { TransformadorDeCiudadanosService } from 'src/app/services/transformador-de-ciudadanos.service';
import { TarjetasService } from 'src/app/services/ciudadanos/tarjetas/tarjetas.service';
import { Grid } from 'dist/movisat-common-gui/lib/models/grid.model';
import { GridComponent } from 'movisat-common-gui';
import { DateUtils } from 'src/app/utils/date-utils';

enum CiudadanoStateText {
  PENDIENTE = "Pendiente",
  VALIDADO = "Validado",
  RECHAZADO = "Rechazado"
}

enum CiudadanoStateId {
  PENDIENTE = 14,
  VALIDADO = 15,
  RECHAZADO = 16
}

export enum VISTAS {
  VISTA_GENERAL = 0,
  CIUDADANOS_ECOLOCK = 1,
}

@Component({
  selector: 'app-ciudadanos',
  templateUrl: './ciudadanos.component.html',
  styleUrls: ['./ciudadanos.component.css']
})
export class CiudadanosComponent extends CustomForms implements OnInit {
  @ViewChild('gridCiudadanos') public gridCiudadanos: GridComponent;
  protected editCiudadanoComponent = viewChild('formCiudadano', { read: ViewContainerRef });
  protected tarjetasCiudadanoComponent = viewChild('tarjetasCiudadano', { read: ViewContainerRef });
  protected formCiudadano: any;
  protected tarjetasCiudadano: any;

  public show = input<boolean>(false);
  @Output() public cargaCompleta: EventEmitter<boolean> = new EventEmitter<boolean>();

  public static _this;

  public showLoader = signal<boolean>(true);
  protected map: MapComponent;
  public environment = environment;
  public langGrid = JqWidgets.getLocalization('es');

  public filterValue: string = '';
  private selectedRow: any[] = [];
  public ciudadanos = signal<CiudadanoModel[]>([]);

  protected firstLoad: boolean = true;
  private toolbarOk: boolean = false;
  public ecoCompostaje = false;
  public ecoIdentificadores = false;
  protected btnValidar;
  protected btnRechazar;

  private windowsOpen = new Map<number, any>();
  protected gridConfig: Grid;
  protected vista = VISTAS.VISTA_GENERAL;


  private tarjetasChangedSubscription: Subscription;

  public constructor(
      private ciudadanosService: CiudadanosService,
      private modal: NzModalService,
      private mapsService: MapsService,
      private exportService: ExportService,
      private userLangService: UserLangService,
      private tarjetaTransformer: TarjetaListTransformerService,
      private ciudadanoTransformer: TransformadorDeCiudadanosService,
      private tarjetasService: TarjetasService
    ) {
    super();
    this.tarjetasChangedSubscription = this.tarjetasService.dataChanged.subscribe(() => {
      this.loadCiudadanos();
    })
    CiudadanosComponent._this = this;
    this.gridConfig = {
      selectionType: "checkbox",
      isGroupable: true,
      localization: this.langGrid,
      updateFilterConditions: this.updatefilterconditions,
      filterType: this.filter,
      columnOpening: this.columnmenuopening,
      toolbar: this.createToolBar,
      sortMode: "many",
      showToolbar: true,
    }
  }

  public static getInstance(): CiudadanosComponent {
    return CiudadanosComponent._this;
  }

  protected get getVistas(): typeof VISTAS {
    return VISTAS;
  }

  public renderTipoVirtual(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {
    if (value) {
      return '<div class="jqx-grid-cell-middle-align" style="margin-top: 8px; cursor: pointer">✅</div>';
    } else {
      return '<div class="jqx-grid-cell-middle-align" style="margin-top: 8px; cursor: pointer">➖</div>';
    }
  }

  public renderTipoFisica(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {
    if (value) {
      return '<div class="jqx-grid-cell-middle-align" style="margin-top: 8px; cursor: pointer">✅</div>';
    } else {
      return '<div class="jqx-grid-cell-middle-align" style="margin-top: 8px; cursor: pointer">➖</div>';
    }
  }

  public renderTipoAPP(
    row: number,
    columnfield: string,
    value: any,
    defaulthtml: string,
    columnproperties: any,
    rowdata: any
  ): string {
    if (value) {
      return '<div class="jqx-grid-cell-middle-align" style="margin-top: 8px; cursor: pointer">✅</div>';
    } else {
      return '<div class="jqx-grid-cell-middle-align" style="margin-top: 8px; cursor: pointer">➖</div>';
    }
  }

  public async ngOnInit(): Promise<void> {
    this.map = MainComponent.getInstance().getMap();
    this.langGrid = JqWidgets.getLocalization(this.userLangService.getUserLangShort());
    const ticketSso: TicketModel = JSON.parse(sessionStorage.getItem('ticketSSO'));

    // Comprueba si tiene el modulo ecoidentificadores
    if (ticketSso && ticketSso.Modulos) {
      ticketSso.Modulos.forEach(ticket => {
        if (ticket.Id === 4) {
          this.ecoIdentificadores = true;
        }
      });

      // Comprueba si esta en la aplicacion de ecoCompostaje
      if (ticketSso.Aplicacion.Id == 4) {
        this.ecoCompostaje = true;
      }
    }
    await this.initGrid();
    await this.loadCiudadanos();
  }

  public onDestroy(): void {
    this.tarjetasChangedSubscription.unsubscribe();
  }

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  public countCiudadanos(): string {
    let nCiudadanos = '0 (0)';

    if (this.gridCiudadanos) {
      nCiudadanos = this.gridCiudadanos?.getRows()?.length + ' (' + this.ciudadanos()?.length + ')';
    }

    return nCiudadanos;
  }

  public loadCiudadanos(): void {
    this.ciudadanosService.getCiudadanos().pipe(
      map(ciudadanosArray =>
        ciudadanosArray.map(ciudadano => {
          let direccionCatastral = '';
          if (ciudadano && ciudadano.catastro) {
            direccionCatastral = ciudadano.catastro.direccion !== '' ? ciudadano.catastro.direccion : '';
            direccionCatastral += ciudadano.catastro.numero !== ''
              ? (direccionCatastral !== '' ? ', ' + ciudadano.catastro.numero : ciudadano.catastro.numero)
              : '';
          }

          let validadoTexto = '';
          if (ciudadano.estadoValidacion === 0 || ciudadano.estadoValidacion === CiudadanoStateId.PENDIENTE) {
            validadoTexto = this.translate(CiudadanoStateText.PENDIENTE);
          } else if (ciudadano.estadoValidacion === 1 || ciudadano.estadoValidacion === CiudadanoStateId.VALIDADO) {
            validadoTexto = this.translate(CiudadanoStateText.VALIDADO);
          } else if (ciudadano.estadoValidacion === 2 || ciudadano.estadoValidacion === CiudadanoStateId.RECHAZADO) {
            validadoTexto = this.translate(CiudadanoStateText.RECHAZADO);
          }

          if (!ciudadano.tarjetas || !Array.isArray(ciudadano.tarjetas)) {
            ciudadano.tarjetas = [];
          }

          ciudadano.tarjetas = ciudadano.tarjetas.map(tarjeta => {
            return this.tarjetaTransformer.transform(tarjeta);
          })

          ciudadano = this.ciudadanoTransformer.transform(ciudadano);

          return { ...ciudadano, direccionCatastral, validadoTexto };
        }).sort((a, b) => (a.id > b.id ? -1 : 1))
      ),
      tap(this.ciudadanos.set),
      tap(() => {
        this.updateCiudadanosGrid();
        this.cargaCompleta.emit(true);
        this.showLoader.set(false);
        this.checkSelect();
      })
    ).subscribe();
  }

  public onGridRendered(event): void {
    if (this.gridCiudadanos === undefined) {
      return;
    }
    this.countCiudadanos();
    this.adjustColumnVisibility();
  }

  private adjustColumnVisibility(): void {
    const columnasMostrarEcolock = ['codCiudadano', 'num_abonado', 'hasVirtual', 'hasFisica', 'hasApp'];
    const columnasOcultarEcolock = ['dni', 'telefono', 'correo_electronico'];

    const columnasMostrarGeneral = ['dni', 'telefono', 'correo_electronico'];
    const columnasOcultarGeneral = ['codCiudadano', 'num_abonado', 'hasVirtual', 'hasFisica', 'hasApp'];

    if (this.vista == VISTAS.CIUDADANOS_ECOLOCK) {
      columnasMostrarEcolock.forEach(col => this.gridCiudadanos.showColumn(col));
      columnasOcultarEcolock.forEach(col => this.gridCiudadanos.hideColumn(col));
    } else if (this.vista == VISTAS.VISTA_GENERAL) {
      columnasMostrarGeneral.forEach(col => this.gridCiudadanos.showColumn(col));
      columnasOcultarGeneral.forEach(col => this.gridCiudadanos.hideColumn(col));
    }
  }

  // Creacion de los botones de accion de las columnas
  public async initBtnColumn(
    row: any,
    column: any,
    value: string,
    htmlElement: HTMLElement
  ): Promise<void> {
    const rowdata = Number.isInteger(row) ? this.gridCiudadanos.getRowData(row) : row.bounddata;
    const ciudadano: CiudadanoModel = this.ciudadanos().find(ciud => ciud.id === rowdata.id);

    htmlElement.innerHTML = '';
    const btnContainer = document.createElement('div');
    btnContainer.style.display = 'flex';
    btnContainer.style.gap = '2px';
    btnContainer.style.padding = '2px';
    btnContainer.style.height = '100%';
    btnContainer.style.justifyContent = 'start';
    btnContainer.style.alignItems = 'center';

    const btnEdit = document.createElement('div');
    btnEdit.innerHTML = `
      <button class="button" style="height: 23px; cursor: pointer;" title="`+ AppComponent.translate('Editar') + `">
        <i class="fa-solid fa-pen-to-square"></i>
      </button>
    `;

    btnEdit.addEventListener('click', () => {
      this.onEditarCiudadano(ciudadano);
    });
    btnContainer.appendChild(btnEdit);

    if (ciudadano.validadoTexto == CiudadanoStateText.PENDIENTE) {
      const btnValidate = document.createElement('div');
      btnValidate.innerHTML = `
        <button class="button" style="height: 23px; cursor: pointer;" title="`+ AppComponent.translate('Validar') + `">
          <i class="fa-solid fa-circle-check"></i>
        </button>
      `;

      btnValidate.addEventListener('click', async () => {
        this.onValidateCiudadano(ciudadano, 15, CiudadanoStateText.VALIDADO);
      });
      btnContainer.appendChild(btnValidate);

      // Boton rechazar
      const btnDecline = document.createElement('div');
      btnDecline.innerHTML = `
        <button class="button" style="height: 23px; cursor: pointer;" title="`+ AppComponent.translate('Rechazar') + `">
          <i class="fa-solid fa-ban"></i>
        </button>
      `;

      btnDecline.addEventListener('click', async () => {
        this.onValidateCiudadano(ciudadano, 16, CiudadanoStateText.RECHAZADO);
      });
      btnContainer.appendChild(btnDecline);
    }

    //Boton para centrar el mapa
    if ((ciudadano?.direccion !== null && ciudadano?.direccion !== '') || (ciudadano?.catastro !== null)) {
      let isPosicionando = false;

      const btnPosicionar = document.createElement('div');
      btnPosicionar.innerHTML = `
        <button class="button" style="height: 23px; cursor: pointer;" title="`+ AppComponent.translate('Posicionar') + `">
          <i class="fa-solid fa-location-dot"></i>
        </button>
      `;

      btnPosicionar.querySelector('button')?.addEventListener('click', async (event) => {
        if (isPosicionando) return;

        const button = event.currentTarget as HTMLButtonElement;
        isPosicionando = true;
        button.disabled = true;

        await this.onPosicionar(ciudadano);

        isPosicionando = false;
        button.disabled = false;
      });

      btnContainer.appendChild(btnPosicionar);
    }
    // Boton ver tarjetas, solo si tiene app ecoIdentificadores
    if (this.ecoIdentificadores && rowdata['num_tarjetas']) {
      const btnSeeCards = document.createElement('div');
      btnSeeCards.innerHTML = `
        <button class="button" style="height: 23px; cursor: pointer;" title="`+ AppComponent.translate('Ver_tarjetas') + `">
          <i class="fa-solid fa-address-card"></i>
        </button>
      `;

      btnSeeCards.addEventListener('click', () => {
        let data;

        if (!row.bounddata) {
          data = this.gridCiudadanos.getRowData(row.boundindex ?? row);
        } else {
          data = this.gridCiudadanos.getRowData(row.bounddata.dataindex);
        }

        this.onSeeTarjetas(data);
      });

      btnContainer.appendChild(btnSeeCards);
    }

    // Boton de borrar
    if (!this.ecoIdentificadores || !rowdata['num_tarjetas']) {
      const btnDelete = document.createElement('div');
      btnDelete.innerHTML = `
        <button class="button" style="height: 23px; cursor: pointer;" title="`+ AppComponent.translate('Borrar') + `">
          <i class="fa-solid fa-trash"></i>
        </button>
      `;

      btnDelete.addEventListener('click', () => {
        this.onBorrarCiudadano(ciudadano);
      });
      btnContainer.appendChild(btnDelete);
    }

    htmlElement.appendChild(btnContainer);
  }

  // Grid ciudadanos
  public columnsGroupCiudadanos;
  public columnsCiudadanos: any = [];
  public sourceCiudadanos;
  public adapterCiudadanos;

  // Inicializacion grid
  public async initGrid(): Promise<void> {

    const camposVisiblesPorRol = await this.ciudadanosService.getCamposVisiblesCiudadanos();

    this.columnsGroupCiudadanos = [
      { text: AppComponent.translate('Direccion_principal'), align: 'center', name: 'accionesGroup' },
    ];

    this.columnsCiudadanos = [
      { text: 'Id', columntype: 'textbox', datafield: 'id', hidden: true },
      { datafield: 'selec', hidden: true },
      {
        width: '195px',
        text: this.translate('Acciones'),
        columntype: 'text',
        editable: false,
        datafield: 'acciones',
        groupable: false,
        menu: false,
        sortable: false,
        clickable: false,
        filterable: false,
        resizable: false,
        pinned: true,
        createwidget: this.initBtnColumn.bind(this),
        initwidget: this.initBtnColumn.bind(this),
      },
      { text: this.translate('Cod_ciudadano'), columntype: 'textbox', datafield: 'codCiudadano', width: 60, hidden: true },
      {
        text: this.translate('Estado'), columntype: 'textbox', datafield: 'estado', width: 90,
        filtertype: 'checkedlist',
        filteritems: [
          this.translate('Pendiente'),
          this.translate('Validado'),
          this.translate('Rechazado')
        ],
      },
      { text: this.translate('Num_tarjetas'), columntype: 'textbox', cellsalign: 'right', datafield: 'num_tarjetas', width: 60, hidden: !this.ecoIdentificadores },
      { text: this.translate('Num_abonado'), columntype: 'textbox', datafield: 'num_abonado', width: 60 },
      { text: this.translate('Nombre'), columntype: 'textbox', datafield: 'nombre', width: 'auto' },
      { text: this.translate('Apellidos'), columntype: 'textbox', datafield: 'apellidos', width: 'auto' },
      { text: this.translate('Virtual'), filtertype: 'checkedlist',columntype: 'textbox', datafield: 'hasVirtual', width: 'auto',cellsrenderer: this.renderTipoFisica ,filteritems: [
        { label: '✅ Virtual', value: true },{ label: '➖ No Virtual', value: false }  ]},
      { text: this.translate('Fisica'), filtertype: 'checkedlist',columntype: 'textbox', datafield: 'hasFisica', width: 'auto', cellsrenderer:this.renderTipoVirtual ,filteritems: [
        { label: '✅ Virtual', value: true },{ label: '➖ No Virtual', value: false }  ]},
      { text: this.translate('App'), filtertype: 'checkedlist',columntype: 'textbox', datafield: 'hasApp', width: 'auto', cellsrenderer:this.renderTipoAPP,filteritems: [
        { label: '✅ Virtual', value: true },{ label: '➖ No Virtual', value: false }  ]},
      { text: this.translate('Dni'), columntype: 'textbox', datafield: 'dni', width: 70 },
      { text: this.translate('Telefono'), columntype: 'textbox', datafield: 'telefono', width: 70 },
      { text: this.translate('Correo_electronico'), columntype: 'textbox', datafield: 'correo_electronico', width: 80 },

      { text: this.translate('Tipo'), columntype: 'textbox', datafield: 'tipo', width: 'auto', hidden: !this.ecoCompostaje },

      { text: this.translate('Numero_catastro'), columntype: 'textbox', datafield: 'numero_catastro', width: 60, hidden: !this.ecoIdentificadores },
      { text: this.translate('Direccion_catastro'), columntype: 'textbox', datafield: 'direccion_catastro', width: 90 },
      { text: this.translate('Titular_catastro'), columntype: 'textbox', datafield: 'titular_catastro', width: 65 },

      { text: this.translate('Direccion'), columntype: 'textbox', datafield: 'direccion', width: 90 },
      { text: this.translate('Numero'), columntype: 'textbox', datafield: 'numero', cellsrenderer: RendererUtils.numberrenderer, width: 30 },
      { text: this.translate('Codigo_postal'), columntype: 'textbox', datafield: 'codigo_postal', width: 60 },
      { text: this.translate('Poblacion'), columntype: 'textbox', datafield: 'poblacion', width: 65 },
      { text: this.translate('Municipio'), columntype: 'textbox', datafield: 'municipio', width: 65 },
      { text: this.translate('Provincia'), columntype: 'textbox', datafield: 'provincia', width: 65 },
      { text: this.translate('Comunidad_autonoma'), columntype: 'textbox', datafield: 'comunidad_autonoma', width: 65 },
      { text: this.translate('Puerta'), columntype: 'textbox', datafield: 'puerta', width: 30 },
      { text: this.translate('Planta'), columntype: 'textbox', datafield: 'planta', width: 30 },
    ];

    // Creo las columnas con los campos visibles
    this.columnsCiudadanos.forEach(column => {
      if (camposVisiblesPorRol.some(f => f.nombreJson == column.datafield)) {
        column.hidden = !this.checkColumnIsVisible(camposVisiblesPorRol, column.datafield);
      }

      column.cellclassname = this.cellClass;

      column.rendered = (element) => {
        const tooltipMessage = column.text;
        Utils.tooltiprenderer(element, tooltipMessage);
      };
    });

    this.sourceCiudadanos = {
      datatype: 'json',
      datafields: [
        { name: 'id', type: 'int', map: 'id' },
        { name: 'codCiudadano', type: 'int', map: 'id' },
        { name: 'selec', map: 'selec' },
        { name: 'acciones', type: 'string' },
        { name: 'estado', type: 'string', map: 'validadoTexto' },
        { name: 'num_tarjetas', type: 'int', map: 'tarjetas>length' },
        { name: 'num_abonado', type: 'int', map: 'numeroAbonado' },

        { name: 'nombre', type: 'string', map: 'nombre' },
        { name: 'apellidos', type: 'string', map: 'apellidos' },
        { name: 'dni', type: 'string', map: 'nif' },
        { name: 'telefono', type: 'int', map: 'telefono' },
        { name: 'correo_electronico', type: 'string', map: 'correoElectronico' },

        { name: 'tipo', type: 'string', map: 'tipo' },
        { name: 'hasFisica', type: 'boolean' },
        { name: 'hasVirtual', type: 'boolean' },
        { name: 'hasApp', type: 'boolean' },
        { name: 'listTypeLabel', type: 'string',  map:'tarjetas>0>listType' },
        { name: 'numero_catastro', type: 'string', map: 'numeroCatastro' },
        { name: 'direccion_catastro', type: 'string', map: 'direccionCatastral' },
        { name: 'titular_catastro', type: 'string', map: 'catastro>titular' },

        { name: 'direccion', type: 'string', map: 'direccion' },
        { name: 'numero', type: 'int', map: 'numero' },
        { name: 'codigo_postal', type: 'int', map: 'codigoPostal' },
        { name: 'poblacion', type: 'string', map: 'poblacion' },
        { name: 'municipio', type: 'string', map: 'municipio' },
        { name: 'provincia', type: 'string', map: 'provincia' },
        { name: 'comunidad_autonoma', type: 'string', map: 'comunidadAutonoma' },
        { name: 'puerta', type: 'string', map: 'puerta' },
        { name: 'planta', type: 'string', map: 'planta' },
      ],
      localdata: [],
    };

    this.adapterCiudadanos = new jqx.dataAdapter(this.sourceCiudadanos);
  }

  private checkColumnIsVisible(visibleColumns, columName: string): boolean {
    const localNameToRemoteNameMap: { [key: string]: string } = {
      'Nombre': 'Nombre',
      'Apellidos': 'Apellidos',
      'Correo electrónico': 'Correo electronico',
      'Código postal': 'Codigo postal',
      'Municipio': 'Municipio',
      'Comunidad autónoma': 'Comunidad autónoma',
      'Puerta': 'Puerta',
      'Planta': 'Planta',
      'Teléfono': 'Telefono',
      'Número': 'Numero',
      'Población': 'Población',
      'Provincia': 'Provincia',
      'Dirección': 'Direccion',
      'Nº Abonado': 'Numero abonado',
      'Número catastro': 'Numero castastro',
      'DNI': 'Nif',
    };

    return true;
  }

  cellClass = (row: number, columnfield: any, value: any): string => {
    if (value) {
      return 'cellTooltip';
    }
    return '';
  }

  updatefilterconditions = (type: string, defaultconditions: any): string[] => {
    return Utils.updatefilterconditions(type, defaultconditions);
  };

  public filter(cellValue?: any, rowData?: any, dataField?: string, filterGroup?: any, defaultFilterResult?: boolean): any {
    let filterColumns = [
      AppComponent.translate('Nombre'),
      AppComponent.translate('Apellidos'),
      AppComponent.translate('Correo_electronico'),
      AppComponent.translate('Direccion_catastro'),
      AppComponent.translate('Titular_catastro'),
      AppComponent.translate('Direccion'),
      AppComponent.translate('Poblacion'),
      AppComponent.translate('Municipio'),
      AppComponent.translate('Provincia'),
      AppComponent.translate('Comunidad_autonoma'),
    ]

    return Utils.filterRow(cellValue, dataField, filterGroup, defaultFilterResult, filterColumns);
  }

  // Crea los componentes de la cabecera
  createToolBar(statusbar: any) {
    if (statusbar[0] !== undefined && !CiudadanosComponent.getInstance().toolbarOk) {
      statusbar[0].style.visibility = 'inherit';
      CiudadanosComponent.getInstance().toolbarOk = true;
      // Añado el control de búsqueda a la cabecera
      const toolbarContainer = document.createElement('div');
      toolbarContainer.style.cssText = `
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  overflow: hidden;
  position: relative;
  margin-left: 4px;
  margin-top: 0px;
`;

      // Contenedor de los botones de la izquierda
      const leftButtonsContainer = document.createElement('div');
      leftButtonsContainer.style.cssText = 'display: flex; align-items: center;padding-bottom: 2px;';

      // Contenedor del botón exportar (a la derecha)
      const rightButtonsContainer = document.createElement('div');
      rightButtonsContainer.style.cssText = 'display: flex; align-items: center;padding-bottom: 2px;';

      // === Search Control ===
      const searchControl: any = document.createElement('div');
      searchControl.id = 'searchControlCiudadano';
      searchControl.style.cssText = `
  background-color: white;
  background-image: url('../assets/images/search.png');
  background-repeat: no-repeat;
  background-position: 4px center;
  background-size: 18px;
  display: flex;
  align-items: center;
  width: 206px;
  margin-top: 2px;
  padding-top: 2px;
  padding-left: 28px;
  height: 25px;
  border: 1px solid rgba(0, 0, 0, 0.5);
  border-radius: 3px;
  overflow: hidden;
`;

      searchControl.innerHTML = `
  <input type="text" style="border: 0;width: 100%; outline: none;"
  placeholder="${AppComponent.translate('Buscar')}..."
  autocorrect="off" autocapitalize="off" spellcheck="off">`;
      leftButtonsContainer.appendChild(searchControl);

      // === Botón Crear ===
      const btnCrear: any = document.createElement('div');
      btnCrear.id = 'btnCrearCiudadano';
      btnCrear.style.cssText = 'height: 25px; width: 85px; padding-left: 3px; padding-top: 2px;';
      btnCrear.innerHTML = `
  <button type="submit" style="width: 80px; height: 25px; align-items: center;cursor: pointer;">
    <div style="float: right; padding-top: 2px;">${AppComponent.translate('Crear')}</div>
    <img style="float: left; height: 18px; width: 18px;" src="../assets/images/mas.png" />
  </button>`;
      leftButtonsContainer.appendChild(btnCrear);

      // === Botón Validar ===
      CiudadanosComponent._this.btnValidar = document.createElement('div');
      CiudadanosComponent._this.btnValidar.id = 'btnValidarCiudadano';
      CiudadanosComponent._this.btnValidar.style.cssText = 'height: 25px; width: 85px; padding-left: 3px; padding-top: 2px;';
      CiudadanosComponent._this.btnValidar.innerHTML = `
  <button type="submit" style="width: 80px; height: 25px; align-items: center;cursor: pointer;">
    <div style="float: right; padding-top: 2px;">${AppComponent.translate('Validar')}</div>
    <img style="float: left; height: 18px; width: 18px;" src="../assets/images/ok.png" />
  </button>`;
      leftButtonsContainer.appendChild(CiudadanosComponent._this.btnValidar);

      // === Botón Rechazar ===
      CiudadanosComponent._this.btnRechazar = document.createElement('div');
      CiudadanosComponent._this.btnRechazar.id = 'btnRechazarCiudadano';
      CiudadanosComponent._this.btnRechazar.style.cssText = 'height: 25px; width: 110px; padding-left: 3px; margin-right: 60px; padding-top: 2px;';
      CiudadanosComponent._this.btnRechazar.innerHTML = `
  <button type="submit" style="width: 105px; height: 25px; align-items: center;cursor: pointer;">
    <div style="float: right; padding-top: 2px;">${AppComponent.translate('Rechazar')}</div>
    <img style="float: left; height: 18px; width: 18px;" src="../assets/images/cancel.png" />
  </button>`;
      leftButtonsContainer.appendChild(CiudadanosComponent._this.btnRechazar);

      // === Botón Vista General ===
      const btnVistaGeneralCiudadanos = document.createElement('div');
      btnVistaGeneralCiudadanos.id = 'btnVistaGeneralCiudadanos';
      btnVistaGeneralCiudadanos.style.cssText = 'height: 25px; padding: 2px;';
      btnVistaGeneralCiudadanos.innerHTML = `
      <button type="submit" style="height: 25px; align-items: center;cursor: pointer;">
      <div style="float: right; padding-top: 2px;">
      <i class="fa fa-eye" aria-hidden="true"></i>
      ${AppComponent.translate('General')}
      </div>
      </button>`;
      leftButtonsContainer.appendChild(btnVistaGeneralCiudadanos);

      // === Botón Vista Ecolock ===
      const btnVistaEcolockCiudadanos = document.createElement('div');
      btnVistaEcolockCiudadanos.id = 'btnVistaEcolockCiudadanos';
      btnVistaEcolockCiudadanos.style.cssText = 'height: 25px; padding: 2px;';
      btnVistaEcolockCiudadanos.innerHTML = `
      <button type="submit" style="height: 25px; align-items: center;cursor: pointer;">
      <i class="fa-solid fa-lock"></i>
      ${AppComponent.translate('Ciudadanos_con_ecolock')}
      </div>
      </button>`;
      leftButtonsContainer.appendChild(btnVistaEcolockCiudadanos);

      // === Botón Exportar ===
      const btnExportar: any = document.createElement('div');
      btnExportar.id = 'btnExportarCiudadano';
      btnExportar.style.cssText = 'height: 25px; padding: 2px;margin-right: 5px;';
      btnExportar.innerHTML = `
  <button type="submit" class="button" title="${AppComponent.translate('Exportar')}" style="width: 35px; height: 25px; align-items: center; cursor: pointer;">
    <i class="fa fa-file-excel fa-lg"></i>
  </button>`;
      rightButtonsContainer.appendChild(btnExportar);

      // Añadir contenedores al toolbar principal
      toolbarContainer.appendChild(leftButtonsContainer);
      toolbarContainer.appendChild(rightButtonsContainer);

      statusbar[0].appendChild(toolbarContainer);
      CiudadanosComponent.getInstance().initToolbarButtons();
      CiudadanosComponent.getInstance().onBuscar();
    }
  }

  // Inicializa el control de búsqueda de la cabecera
  onBuscar(): void {
    const searchControl = document.getElementById('searchControlCiudadano');
    if (searchControl) {
      searchControl.addEventListener('keyup', (event: any) => {
        this.filterValue = '';

        if (event.target.value.length >= 3) {
          this.filterValue = event.target.value;
        }

        this.checkSelect();
      })
    }
  }

  public checkSelect(): void {
    const ciudadanos = this.ciudadanos();

    if (!ciudadanos?.length) {
      return;
    }

    ciudadanos.forEach(ciud => {
      if (
        !this.filterValue ||
        ciud.numeroAbonado?.compareWith(this.filterValue) ||
        ciud.nombre?.compareWith(this.filterValue) ||
        ciud.apellidos?.compareWith(this.filterValue) ||
        ciud.nif?.compareWith(this.filterValue) ||
        ciud.correoElectronico?.compareWith(this.filterValue) ||
        ciud.numeroCatastro?.compareWith(this.filterValue) ||
        ciud.direccionCatastral?.compareWith(this.filterValue) ||
        ciud.catastro?.titular?.compareWith(this.filterValue) ||
        ciud.direccion?.compareWith(this.filterValue) ||
        ciud.poblacion?.compareWith(this.filterValue) ||
        ciud.municipio?.compareWith(this.filterValue) ||
        ciud.provincia?.compareWith(this.filterValue) ||
        ciud.comunidadAutonoma?.compareWith(this.filterValue)
      ) {
        ciud['selec'] = 'selec';
      } else {
        ciud['selec'] = '';
      }
    });

    // Compruebo si ya he creado el filtro "selec" anteriormente
    const filters = this.gridCiudadanos.getFilterInformation();
    if (filters.find(s => s.datafield === 'selec') === undefined) {
      const filtergroup = new jqx.filter();
      filtergroup.operator = 'and';
      filtergroup.addfilter(0, filtergroup.createfilter('stringfilter', 'selec', 'equal'));
      this.gridCiudadanos.addFilter('selec', filtergroup);

    }
      this.gridCiudadanos.applyFilters();
      this.gridCiudadanos.updateBoundData();
  }

  generateAutofilterHeader(sheet) {
    // Añade filtro a todas las casillas.
    sheet['!autofilter'] = { ref: sheet['!ref'] };
  }

  // Inicializa los botones de la cabecera
  initToolbarButtons(): void {
    const btnCrearCiudadano = document.getElementById('btnCrearCiudadano');
    if (btnCrearCiudadano) {
      btnCrearCiudadano.addEventListener('click', (event: any) => {
        CiudadanosComponent._this.onCrearCiudadano();
      });
    }

    const btnValidarCiudadano = document.getElementById('btnValidarCiudadano');
    if (btnValidarCiudadano) {
      btnValidarCiudadano.addEventListener('click', (event: any) => {
        CiudadanosComponent._this.onValidateCiudadanos(15, CiudadanoStateText.VALIDADO);
      });
    }

    const btnRechazarCiudadano = document.getElementById('btnRechazarCiudadano');
    if (btnRechazarCiudadano) {
      btnRechazarCiudadano.addEventListener('click', (event: any) => {
        CiudadanosComponent._this.onValidateCiudadanos(16, CiudadanoStateText.RECHAZADO);
      });
    }

    const btnVistaEcolockCiudadanos = document.getElementById('btnVistaEcolockCiudadanos');
    if (btnVistaEcolockCiudadanos) {
      btnVistaEcolockCiudadanos.addEventListener('click', (event: any) => {

        btnVistaEcolockCiudadanos.classList.add('button-vista-seleccionada');
        btnVistaGeneralCiudadanos.classList.remove('button-vista-seleccionada');

        this.vista = VISTAS.CIUDADANOS_ECOLOCK;
        const ciudadanosConEcolock = this.ciudadanos().filter(c => c.tarjetas?.length > 0);
        this.sourceCiudadanos.localdata = ciudadanosConEcolock;
        this.gridCiudadanos.updateBoundData();
        this.adjustColumnVisibility();
      });
    }

    const btnVistaGeneralCiudadanos = document.getElementById('btnVistaGeneralCiudadanos');
    if (btnVistaGeneralCiudadanos) {
      btnVistaGeneralCiudadanos.classList.add('button-vista-seleccionada');
      btnVistaGeneralCiudadanos.addEventListener('click', (event: any) => {
        btnVistaGeneralCiudadanos.classList.add('button-vista-seleccionada');
      btnVistaEcolockCiudadanos.classList.remove('button-vista-seleccionada');
        this.vista = VISTAS.VISTA_GENERAL;
        this.sourceCiudadanos.localdata = this.ciudadanos();
        this.gridCiudadanos.updateBoundData();
        this.adjustColumnVisibility();
      });
    }


    //boton exportar
    const btnExportar = document.getElementById('btnExportarCiudadano');
    if (btnExportar) {
      btnExportar.addEventListener('click', (event: any) => {
        const data = JSON.parse(JSON.stringify(this.gridCiudadanos.getRows()));
        /*
          Elimino los campos que no se quieren mostrar en el excel
        */
        data.forEach(element => {
          delete element.dataindex;
          delete element.id;
          delete element.uid;
          delete element.uniqueid;
          delete element.visibleindex;
          delete element.boundindex;
          delete element[this.translate('Acciones')];
          delete element.selec;

          if (element[this.translate('Estado')] === 0 || element[this.translate('Estado')] === CiudadanoStateId.PENDIENTE) {
            element[this.translate('Estado')] = this.translate('Pendiente');
          } else if (element[this.translate('Estado')] === 1 || element[this.translate('Estado')] === CiudadanoStateId.VALIDADO) {
            element[this.translate('Estado')] = this.translate('Validado');
          } else if (element[this.translate('Estado')] === 2 || element[this.translate('Estado')] === CiudadanoStateId.RECHAZADO) {
            element[this.translate('Estado')] = this.translate('Rechazado');
          }
        });

        this.gridCiudadanos.hideColumn('acciones');

        this.exportService.exportFile(
          this.gridCiudadanos,
          DateUtils.formatDateAMDhms(new Date()) + '_' + this.translate('Ciudadanos') + '.xlsx'
        );
        this.gridCiudadanos.showColumn('acciones')
      });
    }
  }

  // Ajusto el menu del filtro en funcion de la posicion
  columnmenuopening = (menu: any, datafield: any, height: any): void => {
    if (menu && menu[0]) {
      let menuElement = <HTMLElement>document.getElementById(menu[0].id);
      let areaGestion = <HTMLElement>document.getElementById('ciudadanoGrid').children[1];
      let column = this.gridCiudadanos.getColumn(datafield)['element'];
      let menuTop = 0;

      /* En caso de que vaya a sobresalir por debajo de la pantalla lo ajusto hacia arriba */
      if (height > areaGestion.offsetHeight) {
        menuTop = height - areaGestion.offsetHeight + 100;

        menuElement.parentElement.style.top = '-' + menuTop + 'px';
      }
      else if (height < areaGestion.offsetHeight) {
        menuElement.parentElement.style.top = '0px';
      }

      /* Ajuste del menu para que se vea el boton de filtro en el grid */
      setTimeout(() => {
        let columnPos = column.offsetLeft + column.offsetWidth;
        let menuWidth = menuElement.offsetWidth;

        if (columnPos + menuWidth >= areaGestion.offsetWidth) {
          menuElement.parentElement.style.left = '-20px';
        } else {
          menuElement.parentElement.style.left = '20px';
        }
        /*
          Recoge los desplegables del menu del filtro
          y le añade un evento al hacer click
        */
        let dropDownFilterList = document.getElementsByClassName('jqx-dropdownlist');
        let listBox = document.getElementsByClassName('jqx-listbox-container');
        let arrListFilter: any = Array.from(dropDownFilterList);
        let arrListBox: any = Array.from(listBox);
      }, 0)
    }
  };

  // Se selecciona una fila
  rowSelect(event: any) {
    this.selectedRow.push(event.args.row);

    this.selectedRow.forEach(row => {
      if (row.Estado !== AppComponent.translate('Pendiente')) {
        CiudadanosComponent._this.btnValidar.children[0].disabled = true;
        CiudadanosComponent._this.btnRechazar.children[0].disabled = true;
      }
    });
  }

  rowUnselect(event: any) {
    let index = this.selectedRow.findIndex(row => row.id === event.args.row.id);
    this.selectedRow.splice(index, 1);

    CiudadanosComponent._this.btnValidar.children[0].disabled = false;
    CiudadanosComponent._this.btnRechazar.children[0].disabled = false;

    this.selectedRow.forEach(row => {
      if (row.Estado !== AppComponent.translate('Pendiente')) {
        CiudadanosComponent._this.btnValidar.children[0].disabled = true;
        CiudadanosComponent._this.btnRechazar.children[0].disabled = true;
      }
    });
  }

  public rowDoubleClick(event: any): void {
    const ciudadano = this.ciudadanos().find(x => x?.id === event.args.row.bounddata.id);

    this.onEditarCiudadano(ciudadano);
  }

  private updateCiudadanosGrid(): void {
    this.sourceCiudadanos.localdata = this.ciudadanos();
    this.adapterCiudadanos.dataBind();
    this.gridCiudadanos.updateBoundData();
  }

  public onSaveCiudadano(ciudadano: CiudadanoModel): void {
    const text = this.translate(CiudadanoStateText[CiudadanoStateId[ciudadano.estadoValidacion]])
    ciudadano.validadoTexto = text;
    if (ciudadano.tarjetas && Array.isArray(ciudadano.tarjetas)) {
      ciudadano.tarjetas = ciudadano.tarjetas.map(tarjeta => this.tarjetaTransformer.transform(tarjeta));
    }
    ciudadano = this.ciudadanoTransformer.transform(ciudadano);
    this.ciudadanos.update(ciudadanosArray => {
      const idx = ciudadanosArray.findIndex(c => c.id === ciudadano.id);
      if (idx !== -1) {
        const nuevosCiudadanos = [...ciudadanosArray];
        nuevosCiudadanos[idx] = ciudadano;
        return nuevosCiudadanos;
      } else {
        return [...ciudadanosArray, ciudadano];
      }
    });
    this.updateCiudadanosGrid();
  }

  public createFormCiudadanoComponent(ciudadano: CiudadanoModel = null): void {
    this.formCiudadano = this.editCiudadanoComponent().createComponent(CiudadanosEditComponent);
    this.formCiudadano.instance.init(this.formCiudadano, ciudadano);

    this.formCiudadano.instance.createCiudadano.subscribe(
      ciudadano => this.onSaveCiudadano(ciudadano))
  }

  public onCrearCiudadano(): void {
    this.createFormCiudadanoComponent();
  }

  public onEditarCiudadano(ciudadano: CiudadanoModel): void {
    const btnExpand = <HTMLElement>document.getElementById(`btnExpandCiudadanoEdit${ciudadano?.id}`);

    if (btnExpand) {
      btnExpand.click();
    } else {
      this.createFormCiudadanoComponent(ciudadano);
    }
  }

  public onSeeTarjetas(event: any): void {
    const ciudadano = this.ciudadanos().find(x => x.id === event.id);

    if (this.windowsOpen.has(ciudadano.id)) {
      return;
    }

    this.tarjetasCiudadano = this.tarjetasCiudadanoComponent().createComponent(CiudadanosListadoTarjetasComponent);
    this.tarjetasCiudadano.instance.init(this.tarjetasCiudadano, ciudadano);
    this.windowsOpen.set(ciudadano.id, this.tarjetasCiudadano)

    this.tarjetasCiudadano.instance.onCerrar = (): void => {
      this.windowsOpen.delete(ciudadano.id);
    };
  }

  public onValidateCiudadano(ciudadano: any, state: number, text: string): void {
    this.ciudadanosService.validateCiudadano(ciudadano.id, state).subscribe((validado) => {
      if (validado) {
        this.ciudadanos.update(ciudadanos =>
          ciudadanos.map(c => c.id === ciudadano.id ? { ...c, estadoValidacion: state, validadoTexto: text } : c)
        );
        this.updateCiudadanosGrid();
      }
    });
  }

  public onValidateCiudadanos(state: number, text: string): void {
    this.gridCiudadanos.getSelectedRowIndexes().forEach((element) => {
      const data = this.gridCiudadanos.getRowData(element);
      const ciudadano = this.ciudadanos().find(ciud => ciud.id === data.id);

      this.ciudadanosService.validateCiudadano(ciudadano.id, state)
        .pipe(
          catchError((err) => {
            MainComponent.getInstance().showInfo(
              'ATENCION',
              'Error 3',
              5000,
            );
            return of(-1);
          })
        )
        .subscribe((validado) => {
          if (validado) {
            this.ciudadanos.update(ciudadanos =>
              ciudadanos.map(c =>
                c.id === ciudadano.id ? { ...c, estadoValidacion: state, validadoTexto: text } : c)
            )
            this.updateCiudadanosGrid();
          }
        })
    })
  }

  public async onPosicionar(event: any) {
    if (CiudadanosComponent._this.marker) {
      CiudadanosComponent._this.map.removeMarker(CiudadanosComponent._this.marker);
    }
    //Obtiene las coordenadas
    let coordenadas;
    if (event.direccion) {
      coordenadas = await this.mapsService.getCoordinatesByDirection(
        event.number,
        event.direccion,
        event.municipio,
        event.provincia,
        event.comunidadAutonoma,
        event.codigoPostal,
        event.poblacion
      );
    } else {
      coordenadas = await this.mapsService.getCoordinatesByDirection(
        event.catastro.number,
        event.catastro.direccion,
        event.catastro.municipio,
        event.catastro.provincia,
        event.catastro.comunidadAutonoma,
        event.catastro.codigoPostal,
        event.catastro.poblacion
      );
    }

    // Acerca y centra el mapa
    if (CiudadanosComponent._this.map) {
      CiudadanosComponent._this.map.setZoom(18);
      CiudadanosComponent._this.map.setCenter(new MapLatLng(coordenadas.lat, coordenadas.lng));
    } else {
      this.map = MainComponent.getInstance().getMap();

      CiudadanosComponent._this.map.setZoom(18);
      CiudadanosComponent._this.map.setCenter(new MapLatLng(coordenadas.lat, coordenadas.lng));
    }

    CiudadanosComponent._this.marker = CiudadanosComponent._this.map.addMarker({
      dataModel: event.id,
      title: 'Direccion',
      content: '',
      icon: '/assets/images/elemento.png',
      zIndex: 998,
      visible: true,
      position: new MapLatLng(coordenadas.lat, coordenadas.lng)
    });

    CiudadanosComponent._this.marker.animate(2850);
  }

  /* Muestra la confirmación del borrado */
  public onBorrarCiudadano(ciudadano: CiudadanoModel): void {
    this.modal.confirm({
      nzTitle: '<i>' + this.translate('ATENCION') + '</i>',
      nzContent: this.translate('Borrar_ciudadano') + ' "' + ciudadano.nombre + ' ' + ciudadano.apellidos + '"?',
      nzCentered: true,
      nzCancelText: this.translate('CANCELAR'),
      nzOkText: this.translate('SI'),
      nzOnOk: async () => {
        this.removeCiudadano(ciudadano);
        this.modal.closeAll();
      }
    });
  }

  public async removeCiudadano(ciudadano: CiudadanoModel): Promise<void> {
    if (await this.ciudadanosService.deleteCiudadano(ciudadano.id)) {
      this.ciudadanos.update(ciudadanos => ciudadanos.filter(c => c.id !== ciudadano.id));
      this.updateCiudadanosGrid();
      this.checkSelect();

      if (CiudadanosComponent._this.marker && CiudadanosComponent._this.marker.dataModel === ciudadano.id) {
        CiudadanosComponent._this.map.removeMarker(CiudadanosComponent._this.marker);
      }

      MainComponent.getInstance().showInfo(
        'ATENCION',
        'Registro_borrado',
        2000
      );
    } else {
      MainComponent.getInstance().showWarning(
        'Error',
        'Error_api',
        2000
      );
    }
  }
}
